import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import Container from "component/atom/container/Container";
import ThemeCard from "component/molecules/settings-theme/theme-cards/ThemeCard";
import { settingsEndpoints } from "hooks/endpoints";
import { useFetch } from "hooks/useFetch";
import styles from "./CustomizedThemeTab.module.scss";
import LoadingSpinner from "component/Custom/LoadingSpinner/LoadingSpinner";
import Paginator from "component/molecules/Table/TableComponents/TablePaginator/Paginator";
import { useParams } from "react-router-dom";
import { FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import Loader from "component/atom/loader/Loader";
import NoData from "component/molecules/Table/TableComponents/NoData/NoData";
const CustomizedThemeTab = forwardRef(({ chatSettingsThemeData }, ref) => {
  const { id } = useParams();
  const [query, setQuery] = useState({
    pageSize: 10,
    pageNumber: 1,
  });

  const { data, refetch, isFetching } = useFetch(
    ["customizedResponseThemes", query.pageSize, query.pageNumber, id],
    settingsEndpoints.getCustomResponseThemes(),
    {
      enabled: true,
    },
    {
      pageSize: query.pageSize,
      pageNumber: query.pageNumber,
      BotId: id,
    }
  );
  const fetchedData = data?.data?.items || [];
  const totalItems = data?.data?.totalCount || 0;
  const totalPages = Math.ceil(totalItems / query.pageSize);

  const validationSchema = Yup.object({
    responseThemeId: Yup.number().required("Required"),
  });
  const formik = useFormik({
    initialValues: {
      responseThemeId: data?.data?.responseThemeId || 0,
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {},
  });

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setQuery((prevQuery) => ({
        ...prevQuery,
        pageNumber: page,
      }));
    }
  };

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    refetch();
  }, [query.pageSize, query.pageNumber, refetch]);

  useImperativeHandle(ref, () => ({
    submitForm: () => formik.submitForm(),
  }));

  useEffect(() => {
    ref.current = formik;
  }, [ref, formik]);

  if (isFetching) {
    return <Loader isComponent />;
  }
  return (
    <FormikProvider value={formik}>
      <Container>
        <div className={styles["custom-themes"]}>
          <p className={styles.title}>Choose saved custom themes </p>

          {fetchedData?.length === 0 ? (
            <NoData />
          ) : (
            <ThemeCard
              data={fetchedData}
              chatSettingsThemeData={chatSettingsThemeData}
              id="customResponseId"
              isCustom
            />
          )}
        </div>
        {totalPages > 1 && (
          <Paginator
            onPageChange={handlePageChange}
            currentPage={query.pageNumber}
            totalPages={totalPages}
          />
        )}
      </Container>
    </FormikProvider>
  );
});

export default CustomizedThemeTab;
